import { render } from "./contact.vue?vue&type=template&id=f0968866&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=f0968866&lang=scss&scoped=true"

import exportComponent from "F:\\Code3\\medical-website---web\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_0e94901392e05a49343df8105549c0e4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0968866"]])

export default __exports__